var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"content",staticClass:"content",style:({height: _vm.height > 300 ? 300 + 'px' : 'auto'})},[_c('scrollbar',{attrs:{"occupy":""}},[_vm._v(" "+_vm._s(_vm.content)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }